import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bd9faf8a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  class: "card",
  style: {"min-height":"fit-content","gap":"15px"}
}
const _hoisted_3 = { class: "card" }
const _hoisted_4 = {
  key: 0,
  style: {'text-align': 'center'}
}

import { ref } from "@vue/runtime-core";
import store from "@/store/index.js";
import Pagination from "@/components/Pagination.vue";
import ProfileRow from "@/components/ProfileRow.vue";
import {ProfileResponse} from "@/types/ProfileResponse";
import axios from "axios";
import {NForm, NFormItem, NInput, NSelect} from "naive-ui";
import {useRoute, useRouter} from "vue-router";

interface LooseObject {
    [key: string]: any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ListProfile',
  setup(__props) {

const artists = ref<ProfileResponse | null>({
  count: 1,
  next: null,
  previous: null,
  results: []
})

const route = useRoute()
const router = useRouter()
const currentPage = ref(route.query.page || 1)
const searchQuery = ref(route.query.search || '')
const status = ref(route.query.status || 'Any')
const sort = ref(route.query.sortby || 'full_name')
const order = ref(route.query.order || 'asc')
const wrapper = document.getElementById('wrapper')

getData(currentPage.value)

async function getData(page: any) {
  const query: LooseObject = {}

  page = isNaN(parseInt(page)) ? 1 : parseInt(page)
  currentPage.value = page;

  if (searchQuery.value !== '') {
    page = `${page}&search=${searchQuery.value}`
    query.search = (searchQuery.value as string)
  }

  if (status.value !== 'Any') {
    if (status.value === 'ACTIVE' || status.value === 'INACTIVE') {
      page = `${page}&status=${status.value === 'ACTIVE'}`
      query.status = status.value
    }
  }

  if (sort.value !== '') {
    if (sort.value === 'id' || sort.value === 'full_name' || sort.value === 'email') {
      page = `${page}&ordering=${order.value === 'desc' ? '-' : ''}user__${sort.value}`
      query.sortby = sort.value
      query.order = order.value
    }
  }

  if (currentPage.value > 1)
    query.page = currentPage.value

  await router.push({
    name: 'artists-list',
    query: query
  })

  await axios.get(`/api/profile/all?page=${page}`,
      {headers: {Authorization: `Bearer ${store.state.token}`}}
  ).then(
      response => {
        artists.value = response.data
      }).catch(
      error => {
        console.log(error)
        artists.value = {
          count: 0,
          next: null,
          previous: null,
          results: []
        }
      }
  )

  wrapper!.scroll({top: 0, behavior: 'smooth'})
}

const options = {
  status: [
    {
      label: "Any",
      value: 'Any',
    },
    {
      label: "ACTIVE",
      value: 'ACTIVE',
    },
    {
      label: "INACTIVE",
      value: 'INACTIVE',
    }
  ],
  sort: [
    {
      label: "Full Name",
      value: "full_name",
    },
    {
      label: "Email",
      value: "email",
    },
    {
      label: "Creation Date",
      value: "id",
    }
  ],
  order: [
    {
      label: "Ascending",
      value: "asc",
    },
    {
      label: "Descending",
      value: "desc",
    }
  ]
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(NForm), {
        "label-placement": "top",
        "show-feedback": false
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NFormItem), {
            label: "Who are you searching for?",
            style: {width: '100%'}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NInput), {
                placeholder: "Search by name or email",
                value: searchQuery.value,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                onKeypress: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (getData(1)), ["prevent"]), ["enter"])),
                clearable: ""
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_unref(NFormItem), {
            id: "statusDropdown",
            label: "Status"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSelect), {
                value: status.value,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((status).value = $event)),
                options: options.status
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            class: "brand",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (getData(1)), ["prevent"]))
          }, " Search ")
        ]),
        _: 1
      }),
      _createVNode(_unref(NForm), {
        "label-placement": "top",
        "show-feedback": false
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NFormItem), {
            id: "sortDropdown",
            label: "Sort By"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSelect), {
                value: sort.value,
                "onUpdate:value": [
                  _cache[4] || (_cache[4] = ($event: any) => ((sort).value = $event)),
                  _cache[5] || (_cache[5] = ($event: any) => (getData(1)))
                ],
                "default-value": "full_name",
                options: options.sort
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          }),
          _createVNode(_unref(NFormItem), {
            id: "orderDropdown",
            label: "Order"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NSelect), {
                value: order.value,
                "onUpdate:value": [
                  _cache[6] || (_cache[6] = ($event: any) => ((order).value = $event)),
                  _cache[7] || (_cache[7] = ($event: any) => (getData(1)))
                ],
                options: options.order
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(artists.value.results, (artist, idx) => {
        return (_openBlock(), _createBlock(ProfileRow, {
          artist: artist,
          idx: artist.user.email,
          key: idx
        }, null, 8, ["artist", "idx"]))
      }), 128)),
      (!artists.value.count)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, "No Results"))
        : _createCommentVNode("", true),
      (artists.value.count)
        ? (_openBlock(), _createBlock(Pagination, {
            key: 1,
            maxVisibleButtons: 5,
            totalPages: Math.ceil(artists.value.count/10) || 1,
            perPage: 10,
            currentPage: currentPage.value,
            onPagechanged: getData
          }, null, 8, ["totalPages", "currentPage"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})